import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Subtract } from 'utility-types';

import { getDisplayName } from 'components/hoc';
import { actionCreators as viewAC, getScrollPosition } from 'store/view';
import { ScrollElementIdEnumType } from 'types/ScrollElementId';
// import { SCROLL_ELEMENT_ID } from 'types/ScrollElementId';

export type WithSaveScrollPositionStateType = {};

export type WithSaveScrollPositionsInternalPropsType = {};

export type WithSaveScrollPositionPropsType = {
	scrollPosition: number | null;
	doSaveScrollPosition: (position: number) => void;
	doRestoreLastScrollPosition: () => void;
};

export default function withSaveScrollPosition<P extends WithSaveScrollPositionPropsType>(
	Component: React.ComponentType<P>,
	scrollElementId?: ScrollElementIdEnumType
) {
	const componentName: string = getDisplayName(Component);

	const mapDispatchToProps = (dispatch) => {
		return bindActionCreators(
			{
				doSaveScrollPosition: viewAC.doSaveScrollPosition.bind(null, scrollElementId),
				doRestoreLastScrollPosition: viewAC.doRestoreLastScrollPosition.bind(null, scrollElementId),
			},
			dispatch
		);
	};

	const mapStateToProps = (state) => ({
		scrollPosition: getScrollPosition(state, scrollElementId),
	});

	class SaveScrollPositionProxy extends React.Component<Subtract<P, WithSaveScrollPositionPropsType>> {
		public static displayName = `withSaveScrollPosition(${componentName})`;
		public render() {
			return <Component {...(this.props as P)} />;
		}
	}

	const connector: any = connect(mapStateToProps, mapDispatchToProps);

	return connector(SaveScrollPositionProxy);
}
